// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wrDNk","left":"styles_left__10Olu","desktopActions":"styles_desktopActions__3TAat","title":"styles_title__3X-6o"};